import * as icon from '../../../assets/icons';
import * as L from 'leaflet';

/**
 * Definition of the different icons  depending on the stage and waypoint type--------------------------------------------------------------------------------
 */
export class Icons {
  icons: { [key: string]: L.Icon } = {
    ['Arrival-SetWaypoint']: icon.blueWaypoint,
    ['Arrival-SetWaypoint-Big']: icon.blueBigWaypoint,
    ['Arrival-Loiter']: icon.blueWaypoint,
    ['Arrival-Loiter-Big']: icon.blueBigWaypoint,
    ['Arrival-MissionArea']: icon.blueWaypoint,
    ['Arrival-MissionArea-Big']: icon.blueBigWaypoint,
    ['Arrival-ForkRoute']: icon.blueFork,
    ['Arrival-ForkRoute-Big']: icon.blueBigFork,
    ['Arrival-JoinRoute']: icon.blueJoin,
    ['Arrival-JoinRoute-Big']: icon.blueBigJoin,

    ['VertiportArrival-SetWaypoint']: icon.blueWaypoint,
    ['VertiportArrival-SetWaypoint-Big']: icon.blueBigWaypoint,
    ['VertiportArrival-Loiter']: icon.blueWaypoint,
    ['VertiportArrival-Loiter-Big']: icon.blueBigWaypoint,
    ['VertiportArrival-MissionArea']: icon.blueWaypoint,
    ['VertiportArrival-MissionArea-Big']: icon.blueBigWaypoint,
    ['VertiportArrival-ForkRoute']: icon.blueFork,
    ['VertiportArrival-ForkRoute-Big']: icon.blueBigFork,
    ['VertiportArrival-JoinRoute']: icon.blueJoin,
    ['VertiportArrival-JoinRoute-Big']: icon.blueBigJoin,

    ['Departure-SetWaypoint']: icon.redWaypoint,
    ['Departure-SetWaypoint-Big']: icon.redBigWaypoint,
    ['Departure-Loiter']: icon.redWaypoint,
    ['Departure-Loiter-Big']: icon.redBigWaypoint,
    ['Departure-MissionArea']: icon.redWaypoint,
    ['Departure-MissionArea-Big']: icon.redBigWaypoint,
    ['Departure-ForkRoute']: icon.redFork,
    ['Departure-ForkRoute-Big']: icon.redBigFork,
    ['Departure-JoinRoute']: icon.redJoin,
    ['Departure-JoinRoute-Big']: icon.redBigJoin,

    ['Mission-SetWaypoint']: icon.greenWaypoint,
    ['Mission-SetWaypoint-Big']: icon.greenBigWaypoint,
    ['Mission-Loiter']: icon.greenWaypoint,
    ['Mission-Loiter-Big']: icon.greenBigWaypoint,
    ['Mission-MissionArea']: icon.greenWaypoint,
    ['Mission-MissionArea-Big']: icon.greenBigWaypoint,
    ['Mission-ForkRoute']: icon.greenFork,
    ['Mission-ForkRoute-Big']: icon.greenBigFork,
    ['Mission-JoinRoute']: icon.greenJoin,
    ['Mission-JoinRoute-Big']: icon.greenBigJoin,

    ['DeliveryRoute-SetWaypoint']: icon.greenWaypoint,
    ['DeliveryRoute-SetWaypoint-Big']: icon.greenBigWaypoint,
    ['DeliveryRoute-Loiter']: icon.greenWaypoint,
    ['DeliveryRoute-Loiter-Big']: icon.greenBigWaypoint,
    ['DeliveryRoute-MissionArea']: icon.greenWaypoint,
    ['DeliveryRoute-MissionArea-Big']: icon.greenBigWaypoint,
    ['DeliveryRoute-ForkRoute']: icon.greenFork,
    ['DeliveryRoute-ForkRoute-Big']: icon.greenBigFork,
    ['DeliveryRoute-JoinRoute']: icon.greenJoin,
    ['DeliveryRoute-JoinRoute-Big']: icon.greenBigJoin,

    ['ReturnRoute-SetWaypoint']: icon.greenWaypoint,
    ['ReturnRoute-SetWaypoint-Big']: icon.greenBigWaypoint,
    ['ReturnRoute-Loiter']: icon.greenWaypoint,
    ['ReturnRoute-Loiter-Big']: icon.greenBigWaypoint,
    ['ReturnRoute-MissionArea']: icon.greenWaypoint,
    ['ReturnRoute-MissionArea-Big']: icon.greenBigWaypoint,
    ['ReturnRoute-ForkRoute']: icon.greenFork,
    ['ReturnRoute-ForkRoute-Big']: icon.greenBigFork,
    ['ReturnRoute-JoinRoute']: icon.greenJoin,
    ['ReturnRoute-JoinRoute-Big']: icon.greenBigJoin,

    ['DeliveryArrival-SetWaypoint']: icon.blueWaypoint,
    ['DeliveryArrival-SetWaypoint-Big']: icon.blueBigWaypoint,
    ['DeliveryArrival-Loiter']: icon.blueWaypoint,
    ['DeliveryArrival-Loiter-Big']: icon.blueBigWaypoint,
    ['DeliveryArrival-MissionArea']: icon.blueWaypoint,
    ['DeliveryArrival-MissionArea-Big']: icon.blueBigWaypoint,
    ['DeliveryArrival-ForkRoute']: icon.blueFork,
    ['DeliveryArrival-ForkRoute-Big']: icon.blueBigFork,
    ['DeliveryArrival-JoinRoute']: icon.blueJoin,
    ['DeliveryArrival-JoinRoute-Big']: icon.blueBigJoin,

    ['DeliveryDeparture-SetWaypoint']: icon.redWaypoint,
    ['DeliveryDeparture-SetWaypoint-Big']: icon.redBigWaypoint,
    ['DeliveryDeparture-Loiter']: icon.redWaypoint,
    ['DeliveryDeparture-Loiter-Big']: icon.redBigWaypoint,
    ['DeliveryDeparture-MissionArea']: icon.redWaypoint,
    ['DeliveryDeparture-MissionArea-Big']: icon.redBigWaypoint,
    ['DeliveryDeparture-ForkRoute']: icon.redFork,
    ['DeliveryDeparture-ForkRoute-Big']: icon.redBigFork,
    ['DeliveryDeparture-JoinRoute']: icon.redJoin,
    ['DeliveryDeparture-JoinRoute-Big']: icon.redBigJoin,

    ['Loiter']: icon.greenWaypoint,
    ['Land']: icon.blueLand,
    ['Land-Big']: icon.blueBigLand,

    ['Arrival-Land']: icon.blueLand,
    ['Arrival-Land-Big']: icon.blueBigLand,
    ['Departure-Takeoff']: icon.redTakeoff,
    ['Departure-Takeoff-Big']: icon.redBigTakeoff,
  };

  getIcon(stage: string): L.Icon {
    return this.icons[stage];
  }
}
